import { MAKE_PAYMENT } from "@utils/config";
import { httpsAPICall } from "../apis";

export const makePaymentApi = (data) => {
  const response = httpsAPICall(`${MAKE_PAYMENT}`, data, "get");
  return response;
};
